import { useEffect, useState } from "react";
import { customerSystemsApi } from "@/lib/api";

let cache = null;
const subscribers = new Set();

export const reloadCustomerSystems = () =>
  customerSystemsApi.list().then((r) => {
    cache = r.data;
    subscribers.forEach((fn) => fn(cache));
    return cache;
  });

export function useCustomerSystems() {
  const [systems, setSystems] = useState(cache || []);
  useEffect(() => {
    subscribers.add(setSystems);
    if (!cache) reloadCustomerSystems().catch(() => {});
    return () => subscribers.delete(setSystems);
  }, []);
  return systems;
}
